export const loginUrl = () => `/api/auth/login`;
export const allUsersUrl = (id) => `/api/user/allusers/:${id}`;
export const resetUrl = () => `/api/auth/reset`;
export const getUserDataUrl = () => `/api/auth/reset/:`;
export const resetPassUrl = () => `/api/auth/resetPass/`;
export const signUpUrl = () => `/api/auth/signup`;